import React from "react";
import { useTranslation } from "react-i18next";

import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { EMPTY_STRING, EVENT_BOOKING_TABS } from "../../../constants";
import { Box, Stepper, Step, StepLabel } from "@mui/material";

const ACTIVE_COLOR = "#5FB4BE";
const INACTIVE_COLOR = "#C6C6C6";

const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 19 },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: INACTIVE_COLOR,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: ACTIVE_COLOR,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: ACTIVE_COLOR,
  },
  left: "calc(-50% + 16px) !important",
  right: "calc(50% + 16px) !important",
}));

const CustomStepIconRoot = styled("div")(({ active, completed }) => ({
  color: active || completed ? ACTIVE_COLOR : INACTIVE_COLOR,
  border: `2px solid ${active || completed ? ACTIVE_COLOR : INACTIVE_COLOR}`,
  borderRadius: "50%",
  width: 35,
  height: 35,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

function CustomStepIcon({ active, completed, iconsMap, stepKey }) {
  return (
    <CustomStepIconRoot active={active} completed={completed}>
      <Box
        sx={{
          display: "flex",
          height: 15,
          color: active ? ACTIVE_COLOR : INACTIVE_COLOR,
        }}
        className={active ? "active-icons" : EMPTY_STRING}
      >
        {iconsMap[stepKey]}
      </Box>
    </CustomStepIconRoot>
  );
}

const HorizontalStepper = ({
  activeStep,
  steps,
  onStepClick,
  iconsMap,
  disableInActiveTabs,
  isDraftEvent,
  isAddUpdateRecap,
  TABS_ID,
}) => {
  const { t } = useTranslation("common");

  const stepKeys = Object.keys(steps);

  const visibleStepKeys = isAddUpdateRecap
    ? stepKeys.filter((key) => Number(key) >= TABS_ID.ADD_REEL)
    : stepKeys;

  const activeIndex = isAddUpdateRecap
    ? visibleStepKeys.findIndex((key) => Number(key) === activeStep)
    : activeStep;

  const draftEvent = isDraftEvent
    ? Object.keys(steps).find(
        (key) => steps[key] === EVENT_BOOKING_TABS.EVENT_SETUP
      )
    : null;
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        alternativeLabel
        activeStep={activeIndex}
        connector={<CustomConnector />}
        sx={{ maxWidth: 850, mx: "auto", "& .MuiStep-root": { flex: 1 } }}
      >
        {visibleStepKeys.map((stepKey, index) => {
          const numericKey = Number(stepKey);
          return (
            <Step key={stepKey} sx={{ px: 0 }}>
              <StepLabel
                StepIconComponent={(props) => (
                  <CustomStepIcon
                    {...props}
                    iconsMap={iconsMap}
                    stepKey={numericKey}
                  />
                )}
                onClick={() =>
                  !(draftEvent === stepKey) &&
                  disableInActiveTabs &&
                  onStepClick(numericKey)
                }
                sx={{
                  cursor:
                    numericKey <= activeStep &&
                    disableInActiveTabs &&
                    !(draftEvent === stepKey)
                      ? "pointer"
                      : "not-allowed !important",
                  minWidth: "48px",
                  "& .MuiStepLabel-label": {
                    color:
                      numericKey === activeStep
                        ? `${ACTIVE_COLOR} !important`
                        : "#353535",
                    fontWeight:
                      numericKey === activeStep
                        ? `600 !important`
                        : "400 !important",
                    fontSize: "0.813rem",
                    "@media (max-width:700px)": {
                      fontSize: "0.72rem",
                    },
                  },
                }}
              >
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  {t(steps[stepKey])}
                </Box>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default HorizontalStepper;
